import React, { useEffect, useRef, useState } from "react";
import { Helmet } from 'react-helmet';
import { STRING_CONSTANTS } from "../../../utils/constants/stringConstants";
import { UtilityFunctions } from "../../../utils/UtilityFunctions";
import ChatScreen from "./chatScreen";
import { actionCreators, AppDispatch, State } from "../../../store";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../middleware/api";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import UpgradePlanCheck from "../Home/upgradePlanCheck";
import ChatList from "../Chat/chatList";
import { cookieService, userService } from "../../../_services";
import { END_POINTS } from "../../../utils/constants/endPoints";
import { Data, User } from "../../../_services/collections";
import SocketClient from "../../../library/SocketClient";
import SubscriptionModal from "../Home/SubscriptionModal";
import { fetchSubscriptionChose } from "../../../store/reducers/subscriptionPlans/apiThunk";
import FlagConverstion from "./FlagConverstion";
const debounce = require("debounce-promise");

const Chat = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    setShowSideBarOnMobileView,
    setUnreadNotificationCount,
    getOnlineUserList,
    triggerChatTab
  } = bindActionCreators(actionCreators, dispatch);
  const state = useSelector((state: State) => state);
  const [chatList, setChatList] = useState<any>([]);
  const [selectedChat, setSelectedChat] = useState<any>();
  const [employeeDetails, setEmployeeDetails] = useState<any>();
  const [searchTerm, setSearchTerm] = useState("");
  const [nextURL, setNextURL] = useState("");
  const [archive, setArchive] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState(false);
  const [unreadMsgCount, setUnreadMsgCount] = useState();
  const [latestMessage, setLatestMessage] = useState("");
  const [toggleStatus, setToggleStatus] = useState<boolean>(false);
  const [latestMessageTime, setLatestMessageTime] = useState("");
  const [chatListLength, setChatListLength] = useState<number>(0);
  const [refresh, setRefresh] = useState(false);
  const user = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
  const query = new URLSearchParams(props?.location?.search);
  const updatedChatId = query?.get("chatid");
  const reloadHandling = query?.get("reload");
  const selectedChatRef = useRef(null);
  const [chatSelected, setChatSelected] = useState(false);
  const [subsModalVisibility, setSubsModalVisibility] = useState(false);
  const [flag, setFlag] = useState(false);
  const userType = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);

  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchDataChose = async () => {
      try {
        const res = await dispatch(fetchSubscriptionChose());
        if (userType?.user?.type === STRING_CONSTANTS.userType.employer) {
          if (Object.keys(res.payload).length === 0) {
            setSubsModalVisibility(true);
          } else {
            setSubsModalVisibility(false);
          }
        } else {
          setSubsModalVisibility(false);
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }
    };

    fetchDataChose();
  }, []);


  useEffect(() => {
    triggerChatTab(true)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      getOnlineUserList(true);
    }, 1000);
    setTimeout(() => {
      getOnlineUserList(false);
    }, 2000);

    if (updatedChatId != null && reloadHandling !== "false") {
      if (chatList?.length > 0) {
        api.get(`${updatedChatId}/chat/?limit=25`, null).then((res) => {
          setArchive(res?.results?.room?.isArchived || false);

          setTimeout(() => {
            if (document.getElementById(updatedChatId) && chatList?.length > 0)
              document.getElementById(updatedChatId)?.click();
          }, 2000);
        });
      }
    }
  }, [updatedChatId, chatList]);

  const fetchMoreData = () => {
    setTimeout(() => {
      if (hasMore) {
        const nextPage = nextURL?.split(UtilityFunctions.API_URL())?.[1];
        api.get(nextPage, null).then((res) => {
          if (res.next) {
            setNextURL(res.next);
            setHasMore(true);
          } else {
            setHasMore(false);
          }
          setUnreadMsgCount(res.results.unreadChatsCount);
          setChatList((prevState) => [...prevState, ...res.results.rooms]);
        });
      }
    }, 100);
  };
  useEffect(() => {
    if (refresh === true) {
      getChatList();
    }
  }, [refresh, selectedChat]);

  useEffect(() => {
    getChatList();
  }, [searchTerm, archive, flag, state?.chatReducer?.current_user_latest_message]);

  useEffect(() => {
    if (state?.chatReducer?.current_user_latest_message) {
      let currentUserLatestMessage =
        state?.chatReducer?.current_user_latest_message;
      //   console.log(
      //     '8765redfghjhgfghjgfdghj',
      //     JSON.stringify(currentUserLatestMessage),
      //   );
      let flag = 0;

      let filteredData = chatList?.filter((item, index) => {
        // console.log(
        //   '765efghjgffghjfdfghj',
        //   JSON.stringify(item),
        //   '----------------------------------->',
        //   JSON.stringify(currentUserLatestMessage),
        // );
        if (item?.id !== currentUserLatestMessage?.id) {
          return item;
          // flag = 1;
          // Alert.alert(JSON.stringify(currentUserLatestMessage?.chat));
          // return currentUserLatestMessage;
        }
      });
      //   console.log('765efghuhgfcvhjhj', JSON.stringify(filteredData));
      setChatList([currentUserLatestMessage, ...filteredData]);
      // if (flag == 0) {
      //   setData([currentNotificationData, ...modifiedData]);
      // } else {
      //   setData(modifiedData);
      // }
    }
  }, [state?.chatReducer?.current_user_latest_message]);

  const getChatList = () => {
    if (!archive && !flag) {
      api.get(`chat/rooms/?search=${searchTerm}&limit=10`, null).then((res) => {
        //console.log("chatlist", res.results.rooms);
        setChatListLength(res?.results?.rooms?.length);
        if (res?.next) {
          setNextURL(res?.next);
          setHasMore(true);
        } else {
          setHasMore(false);
        }
        setUnreadMsgCount(res?.results.unreadChatsCount);
        setChatList(res?.results.rooms);

      });
    } else if (archive) {
      // api
      //   .get(`chat/rooms/?search=${searchTerm}&archived=true&limit=10`, null)
      //   .then((res) => {
      //     if (res?.next) {
      //       setNextURL(res?.next);
      //       setHasMore(true);
      //     } else {
      //       setHasMore(false);
      //     }
      //     setUnreadMsgCount(res?.results.unreadChatsCount);
      //     setChatList(res?.results.rooms);
      //   });

      api
        .get(`chat/archive-rooms/`, null)
        .then((res) => {

          // console.log(res, "archive")
          // if (res?.next) {
          //   // setNextURL(res?.next);
          //   // setHasMore(true);
          // } else {
          //   // setHasMore(false);
          // }
          // setUnreadMsgCount(res?.results.unreadChatsCount);
          // console.log(res, "archvied")
          setChatList(res?.rooms);
        }).catch((err) => {
          console.log(err, "errarchive")
        });
    } else if (flag) {
      api
        .get(`chat/flag-rooms/`, null)
        .then((res) => {

          // console.log(res, "flag")
          // if (res?.next) {
          //   setNextURL(res?.next);
          //   setHasMore(true);
          // } else {
          //   setHasMore(false);
          // }
          // setUnreadMsgCount(res?.results.unreadChatsCount);
          setChatList(res?.rooms);
        }).catch((err) => {
          // console.log(err, "errarchive")
        });
    }
  };
  const isUserOnline = (id) => {
    return state?.chatReducer?.online_user_list?.includes(id);
  };

  const allChatList = chatList?.map((chat) => {
    return (
      <div
        id={chat?.id}
        ref={selectedChatRef}
        key={chat?.id}
        className={`chat-gird-s d-grid d-lg-flex align-items-center ${!(chat?.chat?.isRead || chat?.chat?.is_read) &&
          chat?.chat?.content &&
          "active"
          } ${chat.id == selectedChat?.id && "selected-chat"}`}
        onClick={() => {

          setTimeout(() => {
            setChatSelected(false);
          }, 500);
          setTimeout(() => {
            setChatSelected(true);
          }, 1000);
          if (user?.user?.type === STRING_CONSTANTS.userType.employer) {
            if (chat.id !== selectedChat?.id) {
              // console.log(chat)
              api
                .get(
                  `${chat?.employee?.employee?.id}/employee-employer/?jobId=${chat?.job?.id}`,
                  null
                )
                .then((res) => {
                  setEmployeeDetails(res);
                });
              props.history.push(
                `/dashboard/chat?chatid=${chat?.id}&reload=${false}`
              );
              chat.id != selectedChat?.id && setSelectedChat(chat);
              setShowSideBarOnMobileView(!state.common.showSidebarOnMobileView);
              setRefresh(false);
            } else return;
          } else {
            if (chat.id != selectedChat?.id) {
              props.history.push(
                `/dashboard/chat?chatid=${chat?.id}&reload=${false}`
              );
              chat.id != selectedChat?.id && setSelectedChat(chat);
              setShowSideBarOnMobileView(!state.common.showSidebarOnMobileView);
              setRefresh(false);
            } else return;
          }
        }}
      >
        {user?.user.type === STRING_CONSTANTS.userType.employer ? (
          <>
            {chat.id == selectedChat?.id &&

              <div className="" style={{
                width: "6px", height: "94px", backgroundColor: ' #06EFC5', marginLeft: "-20px", marginTop: "-12px", marginBottom: "-16px"
              }}></div>}
            <div className="img-part">
              <img
                src={
                  chat?.employee?.employee?.profilePhoto ||
                  chat?.employee?.employee?.profile_photo ||
                  UtilityFunctions.getImageURL() + "chat-list-profile.png"
                }
              />
              <p className="mb-0" style={{
                background: "#9256e8",
                width: "100%",
                fontSize: "8px",
                color: "white",
                borderRadius: "10px",
                paddingLeft: "2px",
                marginTop: "4px",
              }}>Advanced</p>
              {/* green dot for online status  */}
              {isUserOnline(chat?.employee?.id) &&
                chat?.job?.status !== "cancelled" ? (
                <span></span>
              ) : (
                <span style={{ backgroundColor: "white" }}></span>
              )}
            </div>
            <div className="chat-right-v w-100">
              <h5>
                <p className="letext">
                  {(!chat?.employee?.employee && "User Deleted") ||
                    chat?.employee?.employee?.firstName ||
                    chat?.employee?.employee?.first_name}
                </p>
                <span className="ritext">
                  {(!chat?.job && "Job Deleted") || chat?.job?.title}
                </span>
              </h5>
              <div className="bottom-dta">
                <p>
                  {(chat?.id === selectedChat?.id && latestMessage) ||
                    chat?.chat?.content ||
                    "Send a message to start the conversation"}
                </p>
                <ChatList
                  chat={chat}
                  latestMessage={latestMessage}
                  latestMessageTime={latestMessageTime}
                  selectedChat={selectedChat}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            {chat.id == selectedChat?.id &&

              <div className="" style={{
                width: "6px", height: "94px", backgroundColor: ' #06EFC5', marginLeft: "-20px", marginTop: "-12px", marginBottom: "-16px"
              }}></div>}
            <div className="img-part ">
              <img
                src={
                  chat?.employer?.employer?.logo ||
                  UtilityFunctions.getImageURL() + "bildeing-squre-img.png"
                }
              />
              {/* green dot for online status  */}
              {isUserOnline(chat?.employer?.id) &&
                chat?.job?.status !== "cancelled" ? (
                <span></span>
              ) : (
                <span style={{ backgroundColor: "white", bottom: "0px" }}></span>
              )}
            </div>
            <div className="chat-right-v w-100">
              <h5>
                <p className="letext">
                  {(!chat?.employer?.employer && "User Deleted") ||
                    chat?.employer?.employer?.tradingName ||
                    chat?.employer?.employer?.trading_name}
                </p>
                <span className="ritext">
                  {(!chat?.job && "Job Deleted") || chat?.job?.title}
                </span>
              </h5>
              <div className="bottom-dta">
                <p>
                  {(chat?.id === selectedChat?.id && latestMessage) ||
                    chat?.chat?.content ||
                    "Send a message to start the conversation"}
                </p>
                <ChatList
                  chat={chat}
                  latestMessage={latestMessage}
                  latestMessageTime={latestMessageTime}
                  selectedChat={selectedChat}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  });

  const debounceClick = debounce((value) => {
    setSearchTerm(value);
  }, 1000);

  return (
    <section className="main-dashboard-wrap">
      <Helmet><title>MPLOI - Chat</title></Helmet>
      {/* <SocketClient/> */}
      <div id="wrapper">
        <ul
          className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${state.common.showSidebarOnMobileView ? "active" : ""
            }`}
          id="accordionSidebar"
        >
          <div>
            <Link
              style={{ pointerEvents: "none" }}
              className="sidebar-brand d-flex align-items-center justify-content-center"
              to="/"
            >
              <img src={UtilityFunctions.getImageURL() + "db-logo.svg"} />
            </Link>
            <li className="nav-item">
              <Link className="nav-link" to="/dashboard/home">
                <img
                  src={
                    UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"
                  }
                  alt=""
                />
                <img
                  src={
                    UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"
                  }
                  alt=""
                />
              </Link>
            </li>

            <li className="nav-item notification-nav" style={{ pointerEvents: "none" }}>
              <Link className="nav-link active" to="#offcanvasExample">
                <div className="svg-box">
                  <img src={UtilityFunctions.getImageURL() + "chat-icon.svg"} alt="" />
                  <img src={UtilityFunctions.getImageURL() + "chat-icon-fill-green.svg"} alt="" />
                  {unreadMsgCount ? <span >{unreadMsgCount > 9 ? "9+" : unreadMsgCount}</span> : ""}
                </div>
              </Link>
            </li>

            {false && user?.user?.type === STRING_CONSTANTS.userType.employer && <li className="nav-item">
                  <Link className="nav-link" to="/dashboard/modules">
                      <img src={UtilityFunctions.getImageURL() + "employeesLandingPage/exploreFifth.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="" />
                      <img src={UtilityFunctions.getImageURL() + "employeesLandingPage/exploreFifth.svg"} style={{ filter: 'brightness(0) invert(1)' }} alt="" />
                  </Link>
              </li>}

          </div>

          <div>
            <li className="nav-item">
              <UpgradePlanCheck />
            </li>
          </div>
          <div>
            <li className="nav-item notification-nav">
              <Link className="nav-link" to="/dashboard/notifications">
                <div className="svg-box">
                  <img
                    src={
                      UtilityFunctions.getImageURL() +
                      "bell-icon-blank-white.svg"
                    }
                    alt=""
                  />
                  <img
                    src={
                      UtilityFunctions.getImageURL() +
                      "bell-icon-fill-green.svg"
                    }
                    alt=""
                  />
                  {state?.unreadNotificationCount?.unreadNotificationCount ? (
                    <span>
                      {state?.unreadNotificationCount?.unreadNotificationCount >
                        9
                        ? "9+"
                        : state?.unreadNotificationCount
                          ?.unreadNotificationCount}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/dashboard/settings/">
                <img
                  src={
                    UtilityFunctions.getImageURL() +
                    "settings-icon-blank-white.svg"
                  }
                  alt=""
                />
                <img
                  src={
                    UtilityFunctions.getImageURL() +
                    "settings-icon-fill-green.svg"
                  }
                  alt=""
                />
                {/* <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.0001 10.1783C12.3373 10.1783 10.1787 12.3369 10.1787 14.9997C10.1787 17.6625 12.3373 19.8211 15.0001 19.8211C16.4453 19.8211 17.742 19.1853 18.6256 18.1782C19.3702 17.3296 19.8216 16.2174 19.8216 14.9997C19.8216 14.5069 19.7476 14.0314 19.6103 13.5836C19.0053 11.6119 17.1701 10.1783 15.0001 10.1783ZM11.7859 14.9997C11.7859 13.2245 13.2249 11.7854 15.0001 11.7854C16.7753 11.7854 18.2144 13.2245 18.2144 14.9997C18.2144 16.7749 16.7753 18.214 15.0001 18.214C13.2249 18.214 11.7859 16.7749 11.7859 14.9997ZM23.2601 23.994L21.4092 23.1815C20.8797 22.9494 20.2577 22.9834 19.7573 23.2731C19.2569 23.5629 18.9377 24.0739 18.8741 24.6495L18.6515 26.6627C18.6056 27.0779 18.3044 27.4194 17.8989 27.516C15.9926 27.9705 14.0064 27.9705 12.1001 27.516C11.6945 27.4194 11.3933 27.0779 11.3474 26.6627L11.1252 24.6525C11.06 24.078 10.7264 23.5685 10.2264 23.2798C9.72639 22.991 9.11925 22.9571 8.59148 23.188L6.74018 24.0006C6.35672 24.169 5.909 24.0766 5.62306 23.7702C4.29094 22.3428 3.29932 20.6312 2.72287 18.7643C2.59871 18.3622 2.74217 17.9254 3.08039 17.6758L4.71677 16.4679C5.18287 16.1248 5.45814 15.5799 5.45814 15.0004C5.45814 14.4209 5.18287 13.876 4.71616 13.5324L3.08081 12.3266C2.74208 12.0768 2.59849 11.6395 2.72309 11.237C3.30054 9.37181 4.29267 7.66212 5.62483 6.23659C5.91104 5.93031 6.35898 5.83831 6.74238 6.00706L8.58545 6.81827C9.11578 7.05146 9.72546 7.01623 10.2282 6.72196C10.7287 6.43106 11.062 5.91958 11.1263 5.34387L11.3501 3.33198C11.3969 2.91183 11.705 2.56791 12.1169 2.47613C13.0609 2.26577 14.0241 2.15399 15.0141 2.14258C15.9802 2.15373 16.9424 2.26556 17.8853 2.47626C18.2969 2.56823 18.6047 2.91205 18.6515 3.33198L18.8755 5.34541C18.9769 6.26988 19.7559 6.97007 20.6846 6.97105C20.9342 6.97144 21.1812 6.91935 21.4119 6.8171L23.2553 6.00574C23.6387 5.83699 24.0866 5.92899 24.3728 6.23527C25.705 7.6608 26.6971 9.37049 27.2746 11.2357C27.3991 11.6379 27.2558 12.075 26.9175 12.3248L25.2835 13.5315C24.8174 13.8746 24.5359 14.4195 24.5359 14.999C24.5359 15.5785 24.8174 16.1234 25.2845 16.4673L26.9199 17.6744C27.2583 17.9242 27.4017 18.3614 27.2772 18.7637C26.7 20.6285 25.7084 22.3381 24.377 23.7639C24.0911 24.0701 23.6435 24.1623 23.2601 23.994ZM17.4248 23.7817C17.6768 23.0016 18.2025 22.3163 18.9519 21.8823C19.8967 21.3353 21.0576 21.2725 22.0545 21.7097L23.4945 22.3418C24.4191 21.2716 25.1351 20.0368 25.6053 18.7016L24.3317 17.7616L24.3308 17.7608C23.4623 17.121 22.9287 16.1007 22.9287 14.999C22.9287 13.8981 23.4616 12.8777 24.3293 12.2383L24.3307 12.2373L25.6027 11.2979C25.1324 9.96265 24.416 8.7279 23.491 7.65791L22.0632 8.28635L22.0607 8.28745C21.6263 8.47962 21.1578 8.57882 20.6829 8.57819C18.9339 8.57594 17.4694 7.25785 17.2781 5.5225L17.2779 5.52063L17.1039 3.95648C16.4147 3.82817 15.7155 3.759 15.0141 3.74984C14.2918 3.7592 13.5881 3.82859 12.8977 3.95674L12.7235 5.52235C12.6028 6.60257 11.978 7.56296 11.0379 8.11022C10.0923 8.6628 8.9407 8.73012 7.93802 8.28924L6.50663 7.65923C5.58173 8.72913 4.86541 9.96376 4.3951 11.2989L5.66994 12.2389C6.5478 12.8856 7.06529 13.9108 7.06529 15.0004C7.06529 16.0896 6.54809 17.1149 5.67054 17.7614L4.39472 18.7031C4.86445 20.0401 5.58067 21.2766 6.50591 22.3483L7.94738 21.7155C8.94383 21.2796 10.0884 21.3441 11.0302 21.888C11.9723 22.4321 12.5994 23.3911 12.7221 24.4711L12.7227 24.4759L12.8961 26.0448C14.2851 26.318 15.7139 26.318 17.1029 26.0448L17.2766 24.473C17.3027 24.2372 17.3525 24.0056 17.4248 23.7817Z" fill="white" />
                            </svg> */}
              </Link>
            </li>
            <li className="profile-pic">
              <img
                src={
                  user?.user?.type === STRING_CONSTANTS.userType.employer
                    ? user?.logo ||
                    UtilityFunctions.getImageURL() + "profile-pic.png"
                    : user?.profilePhoto ||
                    UtilityFunctions.getImageURL() +
                    "default-employee-profile-pic-round.svg"
                }
              />
            </li>
          </div>
        </ul>
        <div
          className={`offcanvas offcanvas-start v-chat-sidemenu mobile-outer-bar  ${state.common.showSidebarOnMobileView ? "active" : ""
            }`}
          id="offcanvasExample"
        >
          <div className="submenu-title bg-transparent">
            <div className="btn-row chat-btn-row">
              <ul className="mb-0">
                <li
                  onClick={() => {
                    setSelectedChat("");
                    setArchive(false);
                    setFlag(false);
                  }}
                >
                  <button
                    className={`default-min-link btn-user ${(!archive && !flag) && "active"
                      }`}
                  >
                    <i>
                      <img
                        src={
                          UtilityFunctions.getImageURL() +
                          "person-ico-white.svg"
                        }
                        alt=""
                      />
                      <img
                        src={UtilityFunctions.getImageURL() + "person.svg"}
                        alt=""
                      />

                    </i>
                    <span>Active Chats</span>
                  </button>
                </li>
                <li
                  onClick={() => {
                    setSelectedChat("");
                    setArchive(true);
                    setFlag(false);
                  }}
                >
                  <button
                    className={`default-min-link btn-locatn ${archive && "active"
                      }`}
                  >
                    <i>
                      <img
                        src={
                          UtilityFunctions.getImageURL() +
                          "archive-blank-whtie.svg"
                        }
                        alt=""
                      />
                      <img
                        src={
                          UtilityFunctions.getImageURL() +
                          "archive-fill-pink.svg"
                        }
                        alt=""
                      />

                    </i>
                    <span>Archive</span>
                  </button>
                </li>
                <li
                  onClick={() => {
                    setSelectedChat("");
                    setArchive(false);
                    setFlag(true);
                  }}
                >
                  <button
                    className={`default-min-link btn-flag ${flag && "active"
                      }`}
                  >
                    <i>
                      <img
                        src={
                          UtilityFunctions.getImageURL() +
                          "flag-icon-white.svg"
                        }
                        alt=""
                      />
                      <img
                        src={
                          UtilityFunctions.getImageURL() +
                          "flag-icon-red.svg"
                        }
                        alt=""
                      />

                    </i>
                    <span>Flagged Users</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="logo-wraps chat-searh-boc">
            <div className="search d-flex align-items-center">

              <img
                src={UtilityFunctions.getImageURL() + "search-with-shadow.svg"}
                alt=""
              />
              <input
                type="text"
                className="form-control"
                placeholder="Search User..."
                onChange={(e) => debounceClick(e.target.value)}
              />
            </div>
          </div>
          <div className="total-unread-mes">
            <p>Total Unread Messages ({unreadMsgCount})</p>
          </div>
          <div
            id="scrollableDiv"
            style={{ height: 1000, overflow: "auto" }}
            className="chat-list-data px-0"
          >
            <InfiniteScroll
              dataLength={chatList?.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<h4>Loading...</h4>}
              scrollableTarget="scrollableDiv"
            >
              {allChatList}
            </InfiniteScroll>
          </div>
        </div>

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <span
              className={`mobile-menu othersetups ${state.common.showSidebarOnMobileView ? "active" : ""
                }`}
              onClick={() =>
                setShowSideBarOnMobileView(
                  !state.common.showSidebarOnMobileView
                )
              }
            >
              <span></span>
              <span></span>
              <span></span>
            </span>
            <div className="tab-content" id="v-pills-tabContent">
              <ChatScreen
                employeeDetails={employeeDetails}
                refresh={refresh}
                setRefresh={setRefresh}
                history={props.history}
                chatListLength={chatListLength}
                setLatestMessage={setLatestMessage}
                selectedChat={selectedChat}
                archive={archive}
                getChatList={getChatList}
                toggleStatus={toggleStatus}
                setToggleStatus={setToggleStatus}
                setLatestMessageTime={setLatestMessageTime}
                reloadHandling={reloadHandling}
                setArchive={setArchive}
                flag={flag}
                setFlag={setFlag}
                chatSelected={chatSelected}
                chatList={chatList}
                setSelectedChat={setSelectedChat}


              />
            </div>
          </div>
        </div>
      </div>


    </section>
  );
};

export default Chat;
